import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Privacy = () => {
  const { t } = useTranslation();

  return (
    <div className="bg-gray-900 min-h-screen text-white">
      <header className="bg-gray-800 py-6 px-6">
        <div className="max-w-4xl mx-auto flex items-center">
          <Link to="/" className="flex items-center space-x-2 text-brand hover:text-brand-dark transition-colors">
            <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
            </svg>
            <span>{t('header.backToTenku')}</span>
          </Link>
        </div>
      </header>

      <main className="py-12 px-6">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl font-bold mb-8">{t('legal.privacyTitle')}</h1>

          <div className="prose prose-invert max-w-none">
            <p className="text-gray-300 mb-6">
              <strong>{t('legal.lastUpdated')}</strong> {new Date().toLocaleDateString()}
            </p>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4 text-brand">{t('privacy.section1.title')}</h2>
              <p className="text-gray-300 mb-4">
                {t('privacy.section1.intro')}
              </p>
              <ul className="text-gray-300 space-y-2 ml-6">
                <li>• <strong>{t('privacy.section1.accountInfo')}</strong></li>
                <li>• <strong>{t('privacy.section1.sportsInfo')}</strong></li>
                <li>• <strong>{t('privacy.section1.locationInfo')}</strong></li>
                <li>• <strong>{t('privacy.section1.commInfo')}</strong></li>
                <li>• <strong>{t('privacy.section1.usageInfo')}</strong></li>
                <li>• <strong>{t('privacy.section1.deviceInfo')}</strong></li>
                <li>• <strong>{t('privacy.section1.authInfo')}</strong></li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4 text-brand">{t('privacy.section2.title')}</h2>
              <p className="text-gray-300 mb-4">{t('privacy.section2.intro')}</p>
              <ul className="text-gray-300 space-y-2 ml-6">
                <li>• {t('privacy.section2.connect')}</li>
                <li>• {t('privacy.section2.showGames')}</li>
                <li>• {t('privacy.section2.notifications')}</li>
                <li>• {t('privacy.section2.security')}</li>
                <li>• {t('privacy.section2.support')}</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4 text-brand">{t('privacy.section3.title')}</h2>
              <p className="text-gray-300 mb-4">
                {t('privacy.section3.intro')}
              </p>
              <ul className="text-gray-300 space-y-2 ml-6">
                <li>• {t('privacy.section3.necessary')}</li>
                <li>• {t('privacy.section3.legal')}</li>
                <li>• {t('privacy.section3.safety')}</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4 text-brand">{t('privacy.section4.title')}</h2>
              <p className="text-gray-300 mb-4">
                {t('privacy.section4.intro')}
              </p>
              <ul className="text-gray-300 space-y-2 ml-6">
                <li>• {t('privacy.section4.encryption')}</li>
                <li>• {t('privacy.section4.auth')}</li>
                <li>• {t('privacy.section4.servers')}</li>
                <li>• {t('privacy.section4.monitoring')}</li>
                <li>• {t('privacy.section4.compliance')}</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4 text-brand">{t('privacy.section5.title')}</h2>
              <p className="text-gray-300 mb-4">
                {t('privacy.section5.intro')}
              </p>
              <ul className="text-gray-300 space-y-2 ml-6">
                <li>• {t('privacy.section5.services')}</li>
                <li>• {t('privacy.section5.legal')}</li>
                <li>• {t('privacy.section5.disputes')}</li>
                <li>• {t('privacy.section5.deletion')}</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4 text-brand">{t('privacy.section6.title')}</h2>
              <p className="text-gray-300 mb-4">
                {t('privacy.section6.content')}
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4 text-brand">{t('privacy.section7.title')}</h2>
              <p className="text-gray-300 mb-4">
                {t('privacy.section7.content')}
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4 text-brand">{t('privacy.section8.title')}</h2>
              <p className="text-gray-300 mb-4">{t('privacy.section8.intro')}</p>
              <ul className="text-gray-300 space-y-2 ml-6">
                <li>• {t('privacy.section8.access')}</li>
                <li>• {t('privacy.section8.correct')}</li>
                <li>• {t('privacy.section8.delete')}</li>
                <li>• {t('privacy.section8.portability')}</li>
                <li>• {t('privacy.section8.object')}</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4 text-brand">{t('privacy.section9.title')}</h2>
              <p className="text-gray-300 mb-4">
                {t('privacy.section9.content')}
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4 text-brand">{t('privacy.section10.title')}</h2>
              <p className="text-gray-300">
                {t('privacy.section10.content')}
                <br />
                <strong>{t('privacy.section10.email')}</strong>
              </p>
            </section>
          </div>
        </div>
      </main>

      <footer className="bg-gray-800 py-6 px-6 mt-12">
        <div className="max-w-4xl mx-auto text-center text-gray-400">
          <p>{t('footer.copyright')}</p>
        </div>
      </footer>
    </div>
  );
};

export default Privacy;